
/*
* @license
* PIPELINE Theme (c) Groupthought Themes
*
* This file is included for advanced development by
* Shopify Agencies. Modified versions of the theme
* code are not supported by Shopify or Groupthought.
*
* Add any minor JS changes in assets/custom.js, this
* will make it easier to update the theme in the future.
*
*/
                  
(function() {
    const env = {"NODE_ENV":"production"};
    try {
        if (process) {
            process.env = Object.assign({}, process.env);
            Object.assign(process.env, env);
            return;
        }
    } catch (e) {} // avoid ReferenceError: process is not defined
    globalThis.process = { env:env };
})();

/**
 * Polyfill window.requestIdleCallback and window.cancelIdleCallback since Safari does not yet support them
 */
window.requestIdleCallback =
    window.requestIdleCallback ||
        function (cb) {
            var start = Date.now();
            return setTimeout(function () {
                cb({
                    didTimeout: false,
                    timeRemaining: function () {
                        return Math.max(0, 50 - (Date.now() - start));
                    },
                });
            }, 1);
        };
window.cancelIdleCallback =
    window.cancelIdleCallback ||
        function (id) {
            clearTimeout(id);
        };

/*
  Wraps all tables inside .prose elements in a .rte-table-wrapper class
  Watches newly added content for .prose elements and wraps its tables too.
*/
function wrapTables(container) {
    container.querySelectorAll('.prose table').forEach((table) => {
        const wrapperClass = 'rte-table-wrapper';
        const tableAlreadyWrapped = table.closest(`.${wrapperClass}`);
        if (tableAlreadyWrapped)
            return;
        const parent = table.parentNode;
        const wrapper = document.createElement('div');
        wrapper.classList.add(wrapperClass);
        if (parent) {
            parent.insertBefore(wrapper, table);
            wrapper.appendChild(table);
        }
    });
}
// Wrap all initially rendered .prose tables
wrapTables(document.body);
// Search the newly added content for .prose tables and wrap them too
let observer = new MutationObserver((mutations) => {
    for (let mutation of mutations) {
        if (mutation.target instanceof HTMLElement) {
            if (mutation.target.classList.contains('prose') && mutation.target.parentNode instanceof HTMLElement) {
                wrapTables(mutation.target.parentNode);
            }
            else {
                wrapTables(mutation.target);
            }
        }
    }
});
observer.observe(document.body, {
    childList: true,
    subtree: true,
});
